import { render, staticRenderFns } from "./dataInput.vue?vue&type=template&id=bff0df54&scoped=true&"
import script from "./dataInputControl.js?vue&type=script&lang=js&"
export * from "./dataInputControl.js?vue&type=script&lang=js&"
import style0 from "./dataInput.css?vue&type=style&index=0&id=bff0df54&scoped=true&lang=css&"
import style1 from "./dataInput720.css?vue&type=style&index=1&id=bff0df54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff0df54",
  null
  
)

export default component.exports